
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { ReporterService } from '@/services/index'
import { IReporterData } from '@/types/reporter-types'

@Component({
    name: 'RemoveReporter',
    components: {
    }
})
export default class extends Vue {
    private validateName = (rule: any, value: string, callback: Function) => {
        if (!this.isValidName(value)) {
            callback(new Error('输入记者名不正确'))
        } else {
            callback()
        }
    }
    private visible: boolean = false
    private loading: boolean = false
    private title = ''
    private label: string = ''
    private reporter: any = {}
    private removeReporterCb: any = null
    private infoForm = {}
    private infoRules = {
        name: [
            { required: true, message: '请输入记者名称', trigger: 'blur' },
            { validator: this.validateName, trigger: 'blur' }
        ]
    }

    private isValidName(name: string) {
        if (name === this.reporter.name) {
            return true
        }
        return false
    }

    private show(reporter: IReporterData, removeReporterCb: Function) {
        this.title = '正在删除记者：' + reporter.name
        this.label = '请在下方输入框中输入“' + reporter.name + '”以确认操作'
        this.visible = true
        this.reporter = reporter
        this.removeReporterCb = removeReporterCb
    }

    private close() {
        this.visible = false
    }

    private onSubmit() {
        (this.$refs.infoForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                await this.removeReporter()
                this.loading = false
            } else {
                return false
            }
        })
    }

    private async removeReporter() {
        const params = { id: this.reporter.id, name: this.reporter.name }
        const result = await ReporterService.delete(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '删除成功' })
            this.close()
            this.removeReporterCb && this.removeReporterCb()
        } else {
            this.$message({ type: 'error', message: result.message }) 
        }
    }
}
